import { AUTH_POST, AUTH_PUT, AUTH_GET } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";
import { getSession } from "next-auth/react";

export const createUserSetting = async (settingsPayload: {
  settingsType: string;
  value?: string; // Keep minimal string for quick identification (e.g., report name)
  attributes?: any; // Arbitrary JSON payload
}) => {
  try {
    const url = new URL(`${config.baseURL}/api/users/user-settings`);
    
    // Send settingsType, value, and attributes (if provided)
    const apiPayload: any = {
      settingsType: settingsPayload.settingsType,
      value: settingsPayload.value || ''
    };
    if (settingsPayload.attributes) {
      apiPayload.attributes = settingsPayload.attributes;
    }
    
    console.log('POST Request URL:', url.toString());
  console.log('POST Request Payload:', JSON.stringify(apiPayload));
    
    const response = await AUTH_POST(url.toString(), apiPayload, {
      revalidate: 60,
      tags: ["user-settings"],
    });
    
    console.log('POST Request successful:', response);
    return response;
  } catch (error: any) {
    console.error('POST Request failed:', error);
    throw error;
  }
};

export const getCurrentUserSettings = async () => {
  try {
    // Get the current session to extract user ID
    const session: any = await getSession();
    const userId = session?.user?.id;
    
    if (!userId) {
      console.error('No user ID found in session');
      return [];
    }
    
    console.log('Fetching user data for user ID:', userId);
    const url = new URL(`${config.baseURL}/api/users/${userId}`);
    const response = await AUTH_GET(url.toString());
    
    console.log('User data fetched successfully:', response);
    return response?.userSettings || [];
  } catch (error: any) {
    console.error('Failed to fetch current user settings:', error);
    return [];
  }
};

export const updateUserSetting = async (settingId: string, settingsPayload: {
  settingsType: string;
  value?: string;
}) => {
  try {
    const url = new URL(`${config.baseURL}/api/users/user-settings/${settingId}`);
    
    // Only send settingsType and value to match API specification
    const apiPayload = {
      settingsType: settingsPayload.settingsType,
      value: settingsPayload.value
    };
    
    console.log('PUT Request URL:', url.toString());
    console.log('PUT Request Payload:', JSON.stringify(apiPayload));
    
    const response = await AUTH_PUT(url.toString(), apiPayload, {
      revalidate: 60,
      tags: ["user-settings"],
    });
    
    console.log('PUT Request successful:', response);
    return response;
  } catch (error: any) {
    console.error('PUT Request failed:', error);
    throw error;
  }
};

export default createUserSetting;
